import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import Logo from "../images/twispay-shop-white.png"
import Swiss from "../images/swiss-twispay.svg"
const Header = ({ siteTitle, cartCount }) => (
  <header>
    <div className="headerWrapper">
      <h1 style={{ margin: 0 }}>
        <Link to="/">
          <img className="logo-shop" src={Logo} alt="Twispay Shop Logo"/>
          <img className="swiss" src={Swiss} alt="Swiss Owned"/>
        </Link>
      </h1>
      <div className="menuWrapper">
        <ul>
          <li><a href="//www.twispay.com/product" target="_blank">Product</a></li>
          <li><a href="//www.twispay.com/prices" target="_blank">Pricing</a></li>
          <li><a href="//www.twispay.com/about" target="_blank">Company</a></li>
          <li><a href="//docs.twispay.com/" target="_blank">Developers</a></li>
        </ul>
        <a href="//www.twispay.com/product" className="button is-success is-size-6">Get Started</a>
      </div>
    </div>
  </header >
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
